import { useState } from 'react';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box } from '@mui/material';

import { AccountAddress } from './address';
import { AccountContactPerson } from './contactPerson';
import { AccountContactType } from './contactType';
import { AccountSpecialCondition } from './specialCondition';

import FormView from '../../../../components/views/formView';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { isTrainerOrQuality } from '../../../../../shared/types/profiles';
import {
    ACCOUNTS_EDIT,
    ACCOUNTS_NEW,
    ACCOUNTS,
    ACCOUNTS_DETAIL,
} from '../../../../../routes/paths';

import { useAccountForm } from './hook';
import { AccountHistorical } from '../historical';

export const AccountForm = () => {
    const [showHistorical, setShowHistorical] = useState(false);

    const {
        account,
        loading,
        handleSubmit,
        handleClean,
        setFormikContactPerson,
        setFormikAddress,
        setFormikSpecialCondition,
        setFormikContactType,
        accountHistorical,
    } = useAccountForm(showHistorical);

    const showActionButtons = account && account?.id ? true : false;

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <FormView
                title={account && account.id ? 'Editar cuenta' : 'Crear cuenta'}
                additionalButtons={
                    <ActionButtonGroup
                        id={account?.id || ''}
                        buttonCreate={{
                            show:
                                showActionButtons && !isTrainerOrQuality(type),
                            route: ACCOUNTS_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: ACCOUNTS,
                        }}
                        buttonUpdate={{
                            show:
                                !showActionButtons && !isTrainerOrQuality(type),
                            route: ACCOUNTS_EDIT,
                        }}
                        buttonView={{
                            show: true,
                            route: ACCOUNTS_DETAIL,
                        }}
                        buttonLog={{
                            show: showActionButtons,
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            />
            {showHistorical && (
                <Box sx={{ marginTop: 2 }}>
                    <AccountHistorical
                        historical={accountHistorical ?? []}
                        showHistorical={true}
                    />
                </Box>
            )}
            <AccountContactPerson
                data={account}
                onChangeFormik={(formik) => setFormikContactPerson(formik)}
            />
            <AccountAddress
                data={account?.address}
                onChangeFormik={(formik) => setFormikAddress(formik)}
            />
            <AccountSpecialCondition
                data={account?.specialCondition}
                onChangeFormik={(formik) => setFormikSpecialCondition(formik)}
            />
            <AccountContactType
                data={account?.contactType}
                onChangeFormik={(formik) => setFormikContactType(formik)}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={handleClean}
                />
            </Grid>
        </>
    );
};
